import { map, shareReplay, startWith } from 'rxjs/operators';
import { merge } from 'rxjs';
import { action$, ofType } from '@ardoq/rxbeach';
import { contextWorkspaceOrComponentId$ } from 'streams/context/context$';
import { notifyFiltersChanged } from 'streams/filters/FilterActions';
import { fields$ } from 'streams/fields/fields$';
import { groupingRules$ } from 'streams/grouping/groupingRules$';
import { references$ } from 'streams/references/references$';
import { components$ } from 'streams/components/components$';

// `preserveViewport` is a hint that the upcoming relayout was triggered by
// an in-place edit (component attribute change, reference change) rather
// than a structural change. Only the swimlane view currently consumes it —
// other views ignore the field. See SwimlaneView's onLayoutGraph wrapper
// for the camera snapshot/restore.
const referenceUpdate$ = references$.pipe(
  map(() => ({
    referenceOrderChanged: true,
    isContextChange: false,
    preserveViewport: true,
  }))
);

const inPlaceUpdate$ = components$.pipe(
  map(() => ({
    referenceOrderChanged: false,
    isContextChange: false,
    preserveViewport: true,
  }))
);

const structuralUpdate$ = merge(
  action$.pipe(ofType(notifyFiltersChanged)),
  fields$,
  groupingRules$
).pipe(
  map(() => ({
    referenceOrderChanged: false,
    isContextChange: false,
    preserveViewport: false,
  }))
);

const contextChangeUpdate$ = contextWorkspaceOrComponentId$.pipe(
  map(() => ({
    referenceOrderChanged: false,
    isContextChange: true,
    preserveViewport: false,
  }))
);

const layoutUpdate$ = merge(
  referenceUpdate$,
  inPlaceUpdate$,
  structuralUpdate$,
  contextChangeUpdate$
).pipe(
  startWith({
    referenceOrderChanged: false,
    isContextChange: false,
    preserveViewport: false,
  }),
  shareReplay(1)
);
export { layoutUpdate$ };
